import { Component, lazy, Suspense, useEffect, useState, type ReactNode } from 'react';
import { getSourcePagePdfApi } from './api';
import { useClientAuth } from './auth';

const SinglePagePdf = lazy(() => import('./SinglePagePdf'));
class ReaderBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? <div className="source-page-state" role="alert">
      <p>网页阅读器加载失败，请刷新页面重试或升级浏览器。</p>
      <button className="btn" onClick={() => window.location.reload()}>刷新页面</button>
    </div> : this.props.children;
  }
}

export default function SourcePdfContent({ bookId, page, initialMode, onModeChange, focusText }: {
  bookId: string; page: number; initialMode?: 'pdf' | 'text'; onModeChange?: (mode: 'pdf' | 'text') => void; focusText?:string;
}) {
  const token = useClientAuth(state => state.token);
  const [error, setError] = useState<string>();
  const [data, setData] = useState<Uint8Array>();
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    setData(undefined); setError(undefined);
    if (!Number.isInteger(page) || page <= 0 || page > 2147483647) { setError('原文页地址无效'); return; }
    if (!token) { setError('请登录后查看原文页'); return; }
    const controller = new AbortController();
    const timer = window.setTimeout(() => { controller.abort(); setError('读取原文页超时，请重试'); }, 30000);
    void getSourcePagePdfApi(bookId, page, controller.signal)
      .then(bytes => { if (!controller.signal.aborted) setData(bytes); })
      .catch((reason: unknown) => { if (!controller.signal.aborted) setError(reason instanceof Error ? reason.message : '读取原文页失败'); })
      .finally(() => window.clearTimeout(timer));
    return () => { controller.abort(); window.clearTimeout(timer); };
  }, [bookId, page, token, attempt]);
  if (error) return <div className="source-page-state" role="alert"><p>{error}</p>
    {token && <button className="btn" onClick={() => setAttempt(value => value + 1)}>重新加载</button>}</div>;
  if (!data) return <div className="source-page-state" role="status" aria-live="polite">正在读取原文 PDF 单页…</div>;
  return <ReaderBoundary key={attempt}><Suspense fallback={<div className="source-page-state" role="status">正在准备网页阅读器…</div>}>
    <SinglePagePdf key={attempt} data={data} physicalPage={page} focusText={focusText} initialMode={initialMode} onModeChange={onModeChange} onError={setError} />
  </Suspense></ReaderBoundary>;
}
